(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page-collaboration"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Mobile Banner Slider
    const bannerSlider = document.querySelector('.banner-slides');
    const dots = document.querySelectorAll('.dot');
    let currentSlide = 0;
    let touchStartX = 0;
    let touchEndX = 0;

    // Initialize slider
    function showSlide(index) {
      bannerSlider.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((dot) => dot.classList.remove('active'));
      dots[index].classList.add('active');
      currentSlide = index;
    }

    // Auto slide
    let slideInterval = setInterval(() => {
      let nextSlide = (currentSlide + 1) % 3;
      showSlide(nextSlide);
    }, 5000);

    // Dot navigation
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        clearInterval(slideInterval);
        showSlide(index);
        slideInterval = setInterval(() => {
          let nextSlide = (currentSlide + 1) % 3;
          showSlide(nextSlide);
        }, 5000);
      });
    });

    // Touch events for swipe
    bannerSlider.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    });

    bannerSlider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].clientX;
      handleSwipe();
    });

    function handleSwipe() {
      const swipeDistance = touchEndX - touchStartX;
      if (Math.abs(swipeDistance) > 50) {
        // Minimum swipe distance
        clearInterval(slideInterval);
        if (swipeDistance > 0 && currentSlide > 0) {
          // Swipe right
          showSlide(currentSlide - 1);
        } else if (swipeDistance < 0 && currentSlide < 2) {
          // Swipe left
          showSlide(currentSlide + 1);
        }
        slideInterval = setInterval(() => {
          let nextSlide = (currentSlide + 1) % 3;
          showSlide(nextSlide);
        }, 5000);
      }
    }

    // Navigation Menu
    const navItems = document.querySelectorAll('.nav-item');
    const contentSections = document.querySelectorAll('.content-section');

    navItems.forEach((item) => {
      item.addEventListener('click', () => {
        const targetSection = item.getAttribute('data-section');

        // Update navigation
        navItems.forEach((navItem) => navItem.classList.remove('active'));
        item.classList.add('active');

        // Update content sections
        contentSections.forEach((section) => {
          section.classList.remove('active');
          if (section.classList.contains(targetSection)) {
            section.classList.add('active');
          }
        });
      });
    });

    // Campaign Mobile Expand
    const campaignImages = document.querySelectorAll('.campaign-item:not(.ended) .campaign-image');

    campaignImages.forEach((image) => {
      image.addEventListener('click', function (e) {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          const campaignItem = this.closest('.campaign-item');

          // Close other expanded items
          document.querySelectorAll('.campaign-item').forEach((item) => {
            if (item !== campaignItem && item.classList.contains('active')) {
              item.classList.remove('active');
            }
          });

          // Toggle current item
          campaignItem.classList.toggle('active');
        }
      });
    });

    // Close expanded content when clicking outside
    document.addEventListener('click', function (e) {
      if (window.innerWidth <= 768) {
        const clickedElement = e.target;
        const campaignItem = clickedElement.closest('.campaign-item');

        if (!campaignItem) {
          document.querySelectorAll('.campaign-item.active').forEach((item) => {
            item.classList.remove('active');
          });
        }
      }
    });

    // Show More Campaigns functionality
    window.toggleCampaigns = function () {
      const hiddenCampaigns = document.querySelectorAll('.hidden-campaign');
      const showMoreBtn = document.querySelector('.show-more-campaigns');

      if (hiddenCampaigns.length > 0) {
        hiddenCampaigns.forEach((campaign) => {
          campaign.style.display = 'block';
        });

        // Hide the button after expanding
        if (showMoreBtn) {
          showMoreBtn.style.display = 'none';
        }
      }
    };

    // Ambassador Modal functionality
    window.openAmbassadorModal = function (ambassadorIndex) {
      const ambassadorCard = document.querySelector(`[data-ambassador-id="${ambassadorIndex}"]`);

      if (ambassadorCard) {
        const modalData = ambassadorCard.querySelector('.ambassador-modal-data');
        const modal = document.getElementById('ambassadorModal');

        if (modalData && modal) {
          const image = modalData.querySelector('.modal-image img');
          const name = modalData.querySelector('.modal-name');
          const title = modalData.querySelector('.modal-title');
          const description = modalData.querySelector('.modal-description');

          if (image) {
            document.getElementById('modalImage').src = image.src;
            document.getElementById('modalImage').alt = image.alt;
          }

          if (name) {
            document.getElementById('modalName').textContent = name.textContent;
          }

          if (title) {
            document.getElementById('modalTitle').textContent = title.textContent;
          }

          if (description) {
            document.getElementById('modalDescription').textContent = description.textContent;
          }

          modal.style.display = 'block';
          document.body.style.overflow = 'hidden';
        }
      }
    };

    window.closeAmbassadorModal = function () {
      const modal = document.getElementById('ambassadorModal');
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
      }
    };

    // Close modal when clicking outside
    document.addEventListener('click', function (e) {
      const modal = document.getElementById('ambassadorModal');
      if (e.target === modal) {
        closeAmbassadorModal();
      }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAmbassadorModal();
      }
    });

    // Show More Ambassadors functionality
    // Ambassador 更多按钮功能
    window.toggleAmbassadors = function () {
      const hiddenAmbassadors = document.querySelectorAll('.hidden-ambassador');
      // 筛选出未显示的元素
      let array = [];
      for (let index = 0; index < hiddenAmbassadors.length; index++) {
        if (hiddenAmbassadors[index].style.display !== 'block') {
          array.push(hiddenAmbassadors[index]);
        }
      }
      // 判断显示
      if (array.length > 9) {
        // 多展示九条数据
        for (let index = 0; index <= 8; index++) {
          array[index].style.display = 'block';
        }
      } else {
        // 剩下的全部展示并隐藏按钮
        array.forEach((ambassador) => (ambassador.style.display = 'block'));
        document.querySelector('.show-more-ambassadors').style.display = 'none';
      }
      // 这是旧代码
      // if (hiddenAmbassadors.length > 0) {
      //   hiddenAmbassadors.forEach((ambassador) => {
      //     ambassador.style.display = 'block';
      //   });

      //   // Hide the button after expanding
      //   if (showMoreBtn) {
      //     showMoreBtn.style.display = 'none';
      //   }
      // }
    };

    // Media Carousel functionality Real Moments 切换图片
    window.changeSlide = function (element, direction) {
      // const momentCard = document.querySelector(`[data-moment-id="${momentIndex}"]`);
      const dataMomentDataId = element.getAttribute('data-moment-data-id')
      const momentCard = document.querySelector(`[data-moment-id="${dataMomentDataId}"]`);
      
      if (momentCard) {
        // Try desktop carousel first
        let carousel = momentCard.querySelector('.moment-media-carousel');
        let slides = carousel ? carousel.querySelector('.media-slides') : null;
        let mediaSlides = slides ? slides.querySelectorAll('.media-slide') : null;
        let indicators = carousel ? carousel.querySelectorAll('.indicator') : null;

        // If desktop carousel not found, try mobile carousel
        if (!carousel || !slides || !mediaSlides || mediaSlides.length === 0) {
          carousel = momentCard.querySelector('.mobile-moment-media-carousel');
          slides = carousel ? carousel.querySelector('.mobile-media-slides') : null;
          mediaSlides = slides ? slides.querySelectorAll('.mobile-media-slide') : null;
          indicators = carousel ? carousel.querySelectorAll('.mobile-indicator') : null;
        }

        if (carousel && slides && mediaSlides && mediaSlides.length > 0) {
          let currentIndex = parseInt(carousel.dataset.currentIndex || '0');
          currentIndex += direction;

          if (currentIndex < 0) {
            currentIndex = mediaSlides.length - 1;
          } else if (currentIndex >= mediaSlides.length) {
            currentIndex = 0;
          }

          slides.style.transform = `translateX(-${currentIndex * 100}%)`;
          carousel.dataset.currentIndex = currentIndex;

          // Update indicators
          if (indicators) {
            indicators.forEach((indicator, index) => {
              indicator.classList.toggle('active', index === currentIndex);
            });
          }
        }
      }
    };

    window.currentSlide = function (element, slideIndex) {
      // const momentCard = document.querySelector(`[data-moment-id="${momentIndex}"]`);
      const dataMomentDataId = element.getAttribute('data-moment-data-id')
      const momentCard = document.querySelector(`[data-moment-id="${dataMomentDataId}"]`);
      if (momentCard) {
        // Try desktop carousel first
        let carousel = momentCard.querySelector('.moment-media-carousel');
        let slides = carousel ? carousel.querySelector('.media-slides') : null;
        let indicators = carousel ? carousel.querySelectorAll('.indicator') : null;

        // If desktop carousel not found, try mobile carousel
        if (!carousel || !slides) {
          carousel = momentCard.querySelector('.mobile-moment-media-carousel');
          slides = carousel ? carousel.querySelector('.mobile-media-slides') : null;
          indicators = carousel ? carousel.querySelectorAll('.mobile-indicator') : null;
        }

        if (carousel && slides) {
          const currentIndex = slideIndex - 1;
          slides.style.transform = `translateX(-${currentIndex * 100}%)`;
          carousel.dataset.currentIndex = currentIndex;

          // Update indicators
          if (indicators) {
            indicators.forEach((indicator, index) => {
              indicator.classList.toggle('active', index === currentIndex);
            });
          }
        }
      }
    };

    // Modal Media Carousel functionality
    window.changeModalSlide = function (momentIndex, direction) {
      const modal = document.getElementById('momentModal');
      const carousel = modal.querySelector('.modal-media-carousel');
      const slides = carousel.querySelector('.modal-media-slides');
      const mediaSlides = slides.querySelectorAll('.modal-media-slide');

      let currentIndex = parseInt(carousel.dataset.currentIndex || '0');
      currentIndex += direction;

      if (currentIndex < 0) {
        currentIndex = mediaSlides.length - 1;
      } else if (currentIndex >= mediaSlides.length) {
        currentIndex = 0;
      }

      slides.style.transform = `translateX(-${currentIndex * 100}%)`;
      carousel.dataset.currentIndex = currentIndex;
    };

    // Real Moment Modal functionality
    window.openMomentModal = function (element) {
      const dataMomentDataId = element.getAttribute('data-moment-data-id')
      // console.log(dataMomentDataId)
      const momentCard = document.querySelector(`[data-moment-id="${dataMomentDataId}"]`);
      // console.log(momentCard)

      // const momentCard = document.querySelector(`[data-moment-id="${momentIndex}"]`);

      if (momentCard) {
        // Mark card as clicked to hide hint
        momentCard.classList.add('clicked');

        const modalData = momentCard.querySelector('.moment-modal-data');
        const modal = document.getElementById('momentModal');

        if (modalData && modal) {
          const modalImageContainer = modal.querySelector('.modal-image-container');
          const name = modalData.querySelector('.modal-name');
          const avatar = modalData.querySelector('.modal-avatar');
          const description = modalData.querySelector('.modal-description');
          const socialLinks = modalData.querySelector('.modal-social-links');
          const cartLink = modalData.querySelector('.modal-cart-link');

          // Copy entire media carousel to modal
          const mediaCarousel = modalData.querySelector('.modal-media-carousel');
          if (mediaCarousel && modalImageContainer) {
            modalImageContainer.innerHTML = mediaCarousel.outerHTML;
          }

          if (name) {
            document.getElementById('momentModalName').textContent = name.textContent;
          }

          // Handle avatar
          const modalAvatar = document.getElementById('momentModalAvatar');
          if (avatar && avatar.innerHTML.trim() !== '' && modalAvatar) {
            modalAvatar.innerHTML = avatar.innerHTML;
            modalAvatar.style.display = 'block';
          } else {
            modalAvatar.style.display = 'none';
          }

          if (description) {
            document.getElementById('momentModalDescription').textContent = description.textContent;
          }

          // Copy social links and cart link to modal
          const modalSocialLinks = document.getElementById('momentModalLinks');
          if (socialLinks && modalSocialLinks) {
            modalSocialLinks.innerHTML = socialLinks.innerHTML;
          }

          const modalCartLink = document.getElementById('momentModalCartLink');
          if (cartLink && modalCartLink) {
            modalCartLink.innerHTML = cartLink.innerHTML;
          }

          modal.style.display = 'block';
          document.body.style.overflow = 'hidden';
        }
      }
    };

    window.closeMomentModal = function () {
      const modal = document.getElementById('momentModal');
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';

        // Clear modal content to prevent showing previous data
        const modalImageContainer = modal.querySelector('.modal-image-container');
        const modalName = document.getElementById('momentModalName');
        const modalDescription = document.getElementById('momentModalDescription');
        const modalAvatar = document.getElementById('momentModalAvatar');
        const modalLinks = document.getElementById('momentModalLinks');
        const modalCartLink = document.getElementById('momentModalCartLink');

        if (modalImageContainer) {
          modalImageContainer.innerHTML = '<img id="momentModalImage" src="" alt="" width="auto" height="auto">';
        }
        if (modalName) {
          modalName.textContent = '';
        }
        if (modalDescription) {
          modalDescription.textContent = '';
        }
        if (modalAvatar) {
          modalAvatar.innerHTML = '';
          modalAvatar.style.display = 'none';
        }
        if (modalLinks) {
          modalLinks.innerHTML = '';
        }
        if (modalCartLink) {
          modalCartLink.innerHTML = '';
        }
      }
    };

    // Show More Moments functionality
    // Real Moments 分组下的More按钮
    window.toggleMoments = function (element) {
      // 获取当前显示的real-moments-masonry元素中未显示的moment-card
      const moment_cards = document.querySelectorAll(`.real-moments-masonry[style*='display: block'] .moment-card.hidden-moment`); 
      let num = 0
      if(moment_cards.length>9) num = 9
      else {
        num = moment_cards.length
        element.style.display = 'none'
      }
      for (let index = 0; index < num; index++) {
        moment_cards[index].classList.remove('hidden-moment')
      }
    };

    // Show More Mobile Moments functionality
    window.toggleMobileMoments = function () {
      const hiddenMobileMoments = document.querySelectorAll('.hidden-mobile-moment');
      const showMoreBtn = document.querySelector('.show-more-mobile-moments');

      if (hiddenMobileMoments.length > 0) {
        hiddenMobileMoments.forEach((moment) => {
          moment.style.display = 'block';
        });

        // Hide the button after expanding
        if (showMoreBtn) {
          showMoreBtn.style.display = 'none';
        }
      }
    };

    // Navigation Scroll Button Functionality
    window.scrollNav = function (direction) {
      const collaborationNav = document.querySelector('.mobile-only .collaboration-nav');
      if (!collaborationNav) return;

      const scrollAmount = 150; // Pixels to scroll
      const currentScroll = collaborationNav.scrollLeft;
      const targetScroll =
        direction === 'left' ? Math.max(0, currentScroll - scrollAmount) : currentScroll + scrollAmount;

      collaborationNav.scrollTo({
        left: targetScroll,
        behavior: 'smooth',
      });

      // Update button states after scroll
      setTimeout(() => {
        updateScrollButtons();
      }, 300);
    };

    // Update scroll button states based on scroll position
    function updateScrollButtons() {
      const collaborationNav = document.querySelector('.mobile-only .collaboration-nav');
      const leftBtn = document.querySelector('.nav-scroll-left');
      const rightBtn = document.querySelector('.nav-scroll-right');

      if (!collaborationNav || !leftBtn || !rightBtn) return;

      const isAtStart = collaborationNav.scrollLeft <= 10;
      const isAtEnd = collaborationNav.scrollLeft >= collaborationNav.scrollWidth - collaborationNav.clientWidth - 10;

      leftBtn.disabled = isAtStart;
      rightBtn.disabled = isAtEnd;
    }

    // Mobile Navigation Touch Scroll Enhancement
    function initMobileNavScroll() {
      const collaborationNav = document.querySelector('.mobile-only .collaboration-nav');
      const leftBtn = document.querySelector('.nav-scroll-left');
      const rightBtn = document.querySelector('.nav-scroll-right');

      if (!collaborationNav) return;

      // Add smooth scroll behavior
      collaborationNav.style.scrollBehavior = 'smooth';

      // Update button states on scroll
      collaborationNav.addEventListener('scroll', updateScrollButtons);

      // Initial button state update
      updateScrollButtons();

      // Add click event listeners to buttons
      if (leftBtn) {
        leftBtn.addEventListener('click', (e) => {
          e.preventDefault();
          scrollNav('left');
        });
      }

      if (rightBtn) {
        rightBtn.addEventListener('click', (e) => {
          e.preventDefault();
          scrollNav('right');
        });
      }

      // Optional: Touch scroll support
      let isScrolling = false;
      let startX;
      let scrollLeft;

      collaborationNav.addEventListener('touchstart', (e) => {
        isScrolling = true;
        startX = e.touches[0].pageX - collaborationNav.offsetLeft;
        scrollLeft = collaborationNav.scrollLeft;
      });

      collaborationNav.addEventListener('touchmove', (e) => {
        if (!isScrolling) return;
        e.preventDefault();
        const x = e.touches[0].pageX - collaborationNav.offsetLeft;
        const walk = (x - startX) * 1.5; // Scroll speed multiplier
        collaborationNav.scrollLeft = scrollLeft - walk;
      });

      collaborationNav.addEventListener('touchend', () => {
        isScrolling = false;
        updateScrollButtons();
      });
    }

    // Initialize mobile nav scroll on page load and resize
    initMobileNavScroll();
    window.addEventListener('resize', initMobileNavScroll);

    // Initialize media count indicators for all moments
    function initializeMediaIndicators() {
      const allMoments = document.querySelectorAll('.moment-card, .mobile-moment-card');

      allMoments.forEach((moment) => {
        const videos = moment.querySelectorAll('native-video, external-video');
        const hasVideo = videos.length > 0;
        const mediaSlides = moment.querySelectorAll('.media-slide, .mobile-media-slide');
        const mediaCount = mediaSlides.length;
        const imageCount = mediaCount - videos.length;

        let indicator = moment.querySelector('.media-count-indicator');

        // Only show indicator if there's more than 1 media item
        if (mediaCount > 1) {
          if (!indicator) {
            // Create indicator if it doesn't exist
            indicator = document.createElement('div');
            indicator.className = 'media-count-indicator';
            const mediaContainer = moment.querySelector('.moment-media-container, .mobile-moment-media-container');
            if (mediaContainer) {
              mediaContainer.appendChild(indicator);
            }
          }

          indicator.setAttribute('data-has-video', hasVideo ? 'true' : 'false');
          indicator.setAttribute('data-media-count', mediaCount);

          // Update indicator content
          indicator.innerHTML = '';

          // Add image icon if there are images
          if (imageCount > 0) {
            const imageSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            imageSvg.setAttribute('width', '12');
            imageSvg.setAttribute('height', '12');
            imageSvg.setAttribute('viewBox', '0 0 24 24');
            imageSvg.setAttribute('fill', 'none');
            imageSvg.setAttribute('class', 'image-icon');

            const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            rect.setAttribute('x', '3');
            rect.setAttribute('y', '3');
            rect.setAttribute('width', '18');
            rect.setAttribute('height', '18');
            rect.setAttribute('rx', '2');
            rect.setAttribute('ry', '2');
            rect.setAttribute('stroke', 'currentColor');
            rect.setAttribute('stroke-width', '2');
            rect.setAttribute('fill', 'none');

            const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            circle.setAttribute('cx', '8.5');
            circle.setAttribute('cy', '8.5');
            circle.setAttribute('r', '1.5');
            circle.setAttribute('fill', 'currentColor');

            const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
            polyline.setAttribute('points', '21,15 16,10 5,21');
            polyline.setAttribute('stroke', 'currentColor');
            polyline.setAttribute('stroke-width', '2');
            polyline.setAttribute('fill', 'none');

            imageSvg.appendChild(rect);
            imageSvg.appendChild(circle);
            imageSvg.appendChild(polyline);
            indicator.appendChild(imageSvg);
          }

          // Add video icon if there are videos
          if (hasVideo) {
            const videoSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            videoSvg.setAttribute('width', '12');
            videoSvg.setAttribute('height', '12');
            videoSvg.setAttribute('viewBox', '0 0 24 24');
            videoSvg.setAttribute('fill', 'none');
            videoSvg.setAttribute('class', 'video-icon');

            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('d', 'M8 5v14l11-7z');
            path.setAttribute('fill', 'currentColor');

            videoSvg.appendChild(path);
            indicator.appendChild(videoSvg);
          }

          // Add media count
          const countSpan = document.createElement('span');
          countSpan.className = 'media-count';
          countSpan.textContent = mediaCount;
          indicator.appendChild(countSpan);

          indicator.style.display = 'flex';
        } else {
          // Hide indicator if only 1 media item
          if (indicator) {
            indicator.style.display = 'none';
          }
        }
      });
    }

    // Real Moments Filter functionality
    const filterButtons = document.querySelectorAll('.filter-btn');

    filterButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // Update active button
        filterButtons.forEach((btn) => btn.classList.remove('active'));
        this.classList.add('active');

        const filterType = this.getAttribute('data-filter');
        filterMoments(filterType);
        isShowMore(filterType)
      });
    });
  
    // 点击切换Real Moments分组下的分类按钮
    function filterMoments(filterType) {
      const moments = document.querySelectorAll(`.real-moments-masonry`);
      moments.forEach(element => {
        element.style.display = 'none'
        if(element.getAttribute('data-filter') == filterType){
          element.style.display = 'block'
        }
      });
    }

    // 切换分类后判断more按钮是否重新显示
    function isShowMore(filterType){
      // 由于扩展内容导入进来时是隐藏状态,这里需要判断一下,当前显示不足12条,且还有未显示 item 时,将隐藏的 item 显示出来
      var momentCards =  document.querySelectorAll(`.real-moments-masonry[data-filter=${filterType}] .moment-card`)
      momentCards.forEach((element,index) => {
        if(index < 12 && element.classList.contains('hidden-moment')){
          element.classList.remove('hidden-moment')
        }
      });
      // 
      // 下面是按钮的显示逻辑
      const index = document.querySelectorAll(`.real-moments-masonry[data-filter=${filterType}] .moment-card.hidden-moment`).length
      // 
      const btn = document.querySelectorAll('.show-more-moments-btn')[0]
      if(index > 0) btn.style.display = 'initial'
      else btn.style.display = 'none'
    }

    // Initialize indicators
    initializeMediaIndicators();

    // Optimize masonry layout for mobile
    function optimizeMasonryLayout() {
      if (window.innerWidth <= 768) {
        const mobileGrid = document.querySelector('.mobile-moments-grid');
        if (mobileGrid) {
          // Force reflow to recalculate masonry layout
          const display = mobileGrid.style.display;
          mobileGrid.style.display = 'none';
          mobileGrid.offsetHeight; // Trigger reflow
          mobileGrid.style.display = display;
        }
      }
    }

    // Wait for images to load before optimizing layout
    function waitForImages() {
      const images = document.querySelectorAll('.mobile-moment-card img');
      let loadedImages = 0;

      if (images.length === 0) {
        optimizeMasonryLayout();
        return;
      }

      images.forEach((img) => {
        if (img.complete) {
          loadedImages++;
          if (loadedImages === images.length) {
            setTimeout(optimizeMasonryLayout, 100);
          }
        } else {
          img.addEventListener('load', () => {
            loadedImages++;
            if (loadedImages === images.length) {
              setTimeout(optimizeMasonryLayout, 100);
            }
          });
        }
      });
    }

    // Initialize masonry optimization
    if (window.innerWidth <= 768) {
      waitForImages();

      // Re-optimize on window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (window.innerWidth <= 768) {
            optimizeMasonryLayout();
          }
        }, 250);
      });
    }

    // Close moment modal when clicking outside or pressing Escape
    document.addEventListener('click', function (e) {
      const modal = document.getElementById('momentModal');
      if (e.target === modal) {
        closeMomentModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeMomentModal();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
